import { ButtonHTMLAttributes, ReactNode } from 'react';

import ChevronDownIcon from '@flipster/react/icon/generated/ChevronDownIcon';
import { css, cx } from '@flipster/styled-system/css';
import { triggerChip } from '@flipster/styled-system/recipes';

interface NavigationChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'className' | 'children'> {
  label: ReactNode;
}

export const NavigationChip = ({ label, ...buttonProps }: NavigationChipProps) => {
  const classes = triggerChip({ type: 'rounded', hierarchy: 'primary', highlight: 'off', selected: false });

  return (
    <button type='button' className={cx('group', classes.container)} {...buttonProps}>
      {label != null && <div className={classes.label}>{label}</div>}
      <div className={css({ lineHeight: 0 })}>
        <ChevronDownIcon size={16} />
      </div>
    </button>
  );
};
